export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAUCAYAAABMDlehAAAABHNCSVQICAgIfAhkiAAAABBJREFUCFtjePDkxX8G2hIAUWRJXdQlIQgAAAAASUVORK5CYII="